var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.34,
    y: 5.04,
    width: 13.32,
    height: 13.92
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,19h0a6.77,6.77,0,0,1-5.14-2.23A7.12,7.12,0,0,1,5.13,12,7.12,7.12,0,0,1,6.85,7.27,6.77,6.77,0,0,1,12,5h0a6.77,6.77,0,0,1,5.14,2.23A7.12,7.12,0,0,1,18.87,12a7.12,7.12,0,0,1-1.72,4.73A6.77,6.77,0,0,1,12,19ZM12,6.05a5.72,5.72,0,0,0-5.86,6A5.72,5.72,0,0,0,12,18,5.72,5.72,0,0,0,17.86,12,5.72,5.72,0,0,0,12,6.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.29,6.87c6.79,3.23,1.91,13.57-4.9,10.4h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.94,18.29a6.4,6.4,0,0,1-2.73-.64l.36-.76a5.7,5.7,0,0,0,2.36.56,5.22,5.22,0,0,0,4.63-3.16,5.07,5.07,0,0,0-2.45-7l.36-.76a5.86,5.86,0,0,1,3.28,3.7,6.38,6.38,0,0,1-.43,4.46,6.35,6.35,0,0,1-3.17,3.17A5.45,5.45,0,0,1,11.94,18.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.ef2a0f3f03840fd75bddacd50993f568.svg";
export { ForwardRef as ReactComponent };